module.exports = __webpack_public_path__ + "static/media/arquitect_6.63813830.jpeg";